(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr4-banner-video')) {
    customElements.define('sr4-banner-video', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.button = this.closest('.sr4-banner-inner').querySelector('.sr4-banner-sound');
        this.breakpoint = window.matchMedia('(max-width: 767px)');
        this.changeVideo = () => this.selectVideo();
        this.toggleSound = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!this.video) return;
          this.video.muted = !this.video.muted;
          this.updateButton();
          const playing = this.video.play();
          if (playing) playing.catch(() => {
            this.video.muted = true;
            this.updateButton();
          });
        };
        this.button.addEventListener('click', this.toggleSound);
        this.breakpoint.addEventListener('change', this.changeVideo);
        this.selectVideo();
      }
      selectVideo() {
        if (this.video) {
          this.video.pause();
          this.video.remove();
        }
        const template = this.querySelector(this.breakpoint.matches ? '[data-mobile-video]' : '[data-desktop-video]');
        this.video = template.content.querySelector('video').cloneNode(true);
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.addEventListener('volumechange', () => this.updateButton());
        this.appendChild(this.video);
        this.updateButton();
        const playing = this.video.play();
        if (playing) playing.catch(() => {});
      }
      updateButton() {
        const muted = this.video.muted;
        this.button.dataset.muted = String(muted);
        this.button.setAttribute('aria-pressed', String(!muted));
        this.button.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
        this.button.title = muted ? 'Unmute video' : 'Mute video';
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.video) this.video.pause();
        if (this.breakpoint) this.breakpoint.removeEventListener('change', this.changeVideo);
        if (this.button) this.button.removeEventListener('click', this.toggleSound);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
